// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/octin_sports_rg.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* fonts import */
@font-face {
  font-family: "octin";
  src: local("octin_sports_rg"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
body {
  font-family: "Poppins";
  color: #0c0c0c;
  background-color: #ffffff;
  overflow-x: hidden;
}

.layout_padding {
  padding: 90px 0;
}

.layout_padding2 {
  padding: 45px 0;
}

.layout_padding2-top {
  padding-top: 45px;
}

.layout_padding2-bottom {
  padding-bottom: 45px;
}

.layout_padding-top {
  padding-top: 90px;
}

.layout_padding-bottom {
  padding-bottom: 90px;
}

.long_section {
  margin-left: 45px;
  margin-right: 45px;
  padding-left: 15px;
  padding-right: 15px;
}

.heading_container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.heading_container h1, .heading_container h2 {
  position: relative;
  font-weight: bold;
  text-transform: uppercase;
}

/*header section*/
.hero_area {
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
}

.sub_page .hero_area {
  min-height: auto;
}

.header_section {
  background-color: #ffffff;
}
.header_section .container-fluid {
  padding-right: 25px;
  padding-left: 25px;
}
.header_section .nav_container {
  margin: 0 auto;
}

.custom_nav-container .navbar-nav .nav-item .nav-link {
  padding: 3px 15px;
  margin: 10px 15px;
  color: #272727;
  text-align: center;
  text-transform: uppercase;
}
a,
a:hover,
a:focus {
  text-decoration: none;
}

a:hover,
a:focus {
  color: initial;
}

.btn,
.btn:focus {
  outline: none !important;
  box-shadow: none;
}

.custom_nav-container .nav_search-btn {
  width: 35px;
  height: 35px;
  padding: 0;
  border: none;
}

.navbar-brand span {
  font-size: 24px;
  font-weight: 700;
  color: #272727;
  text-transform: uppercase;
}

.custom_nav-container {
  z-index: 99999;
  padding: 5px 0;
}

.custom_nav-container .navbar-toggler {
  outline: none;
}

.custom_nav-container .navbar-toggler {
  padding: 0;
  width: 37px;
  height: 42px;
  transition: all 0.3s;
}
.custom_nav-container .navbar-toggler span {
  display: block;
  width: 32px;
  height: 4px;
  background-color: #000;
  border-radius: 15px;
  margin: 7px 0;
  transition: all 0.3s;
  position: relative;
  transition: all 0.3s;
}
.custom_nav-container .navbar-toggler span::before, .custom_nav-container .navbar-toggler span::after {
  content: "";
  position: absolute;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: #000000;
  border-radius: 15px;
  top: -10px;
  transition: all 0.3s;
}
.custom_nav-container .navbar-toggler span::after {
  top: 10px;
}
.custom_nav-container .navbar-toggler[aria-expanded=true] {
  transform: rotate(360deg);
}
.custom_nav-container .navbar-toggler[aria-expanded=true] span {
  transform: rotate(45deg);
}
.custom_nav-container .navbar-toggler[aria-expanded=true] span::before, .custom_nav-container .navbar-toggler[aria-expanded=true] span::after {
  transform: rotate(90deg);
  top: 0;
}

.quote_btn-container {
  display: flex;
  align-items: center;
}
.quote_btn-container a {
  color: #151515;
  margin-right: 25px;
  text-transform: uppercase;
}
.quote_btn-container a span {
  margin-right: 5px;
}

/*end header section*/
/* slider section */
.slider_section {
  flex: 1 1;
  display: flex;
  align-items: center;
  position: relative;
  background-color: #f9fafa;
}
.slider_section .row {
  align-items: center;
}
.slider_section #customCarousel {
  width: 100%;
  z-index: 3;
}
.slider_section .detail-box {
  color: #000000;
}
.slider_section .detail-box h1 {
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 0;
}
.slider_section .detail-box p {
  margin: 25px 0;
}
.slider_section .detail-box .btn-box {
  display: flex;
  margin: 0 -5px;
}
.slider_section .detail-box .btn-box a {
  margin: 5px;
  text-align: center;
  width: 165px;
}
.slider_section .detail-box .btn-box .btn1 {
  display: inline-block;
  padding: 10px 15px;
  background-color: #f89646;
  color: #ffffff;
  border-radius: 0;
  border: 1px solid #f89646;
  transition: all 0.2s;
}
.slider_section .detail-box .btn-box .btn1:hover {
  background-color: transparent;
  color: #f89646;
}
.slider_section .detail-box .btn-box .btn2 {
  display: inline-block;
  padding: 10px 15px;
  background-color: #6bb7be;
  color: #ffffff;
  border-radius: 0;
  border: 1px solid #6bb7be;
  transition: all 0.2s;
}
.slider_section .detail-box .btn-box .btn2:hover {
  background-color: transparent;
  color: #6bb7be;
}
.slider_section .img-box img {
  width: 100%;
}
.slider_section .carousel-indicators {
  position: unset;
  margin: 0;
  justify-content: center;
  align-items: center;
  margin-top: 45px;
}
.slider_section .carousel-indicators li {
  background-color: #6bb7be;
  width: 12px;
  height: 12px;
  border-radius: 100%;
  opacity: 1;
}
.slider_section .carousel-indicators li.active {
  width: 17px;
  height: 17px;
  background-color: #f89646;
}

.furniture_section .box {
  margin-top: 45px;
  background-color: #f7fafa;
  padding: 25px;
  border-radius: 5px;
}
.furniture_section .box .img-box {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 275px;
  padding: 25px;
}
.furniture_section .box .img-box img {
  max-width: 100%;
  max-height: 100%;
}
.furniture_section .box .detail-box {
  margin-top: 15px;
}
.furniture_section .box .detail-box h5 {
  text-transform: uppercase;
  font-size: 18px;
}
.furniture_section .box .detail-box .price_box {
  display: flex;
  justify-content: space-between;
}
.furniture_section .box .detail-box .price_box .price_heading {
  margin-bottom: 0;
}
.furniture_section .box .detail-box .price_box .price_heading span {
  color: #6bb7be;
}
.furniture_section .box .detail-box .price_box a {
  color: #6bb7be;
  text-transform: uppercase;
  font-size: 15px;
}

.about_section {
  background-color: #f9fafa;
}
.about_section .row {
  align-items: center;
}
.about_section .img-box img {
  width: 100%;
}
.about_section .detail-box p {
  margin-top: 10px;
  margin-bottom: 35px;
}
.about_section .detail-box a {
  display: inline-block;
  padding: 10px 45px;
  background-color: #6bb7be;
  color: #ffffff;
  border-radius: 0;
  border: 1px solid #6bb7be;
  transition: all 0.2s;
}
.about_section .detail-box a:hover {
  background-color: transparent;
  color: #6bb7be;
}

.blog_section .heading_container {
  align-items: center;
}
.blog_section .heading_container h2::before {
  left: 50%;
  transform: translateX(-50%);
}
.blog_section .box {
  margin-top: 55px;
  background-color: #ffffff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
}
.blog_section .box .img-box {
  position: relative;
}
.blog_section .box .img-box img {
  width: 100%;
}
.blog_section .box .detail-box {
  padding: 25px;
}
.blog_section .box .detail-box h5 {
  font-weight: bold;
}
.blog_section .box .detail-box p {
  font-size: 15px;
  color: #444;
}
.blog_section .box .detail-box a {
  display: inline-block;
  padding: 10px 30px;
  background-color: #6bb7be;
  color: #ffffff;
  border-radius: 0;
  border: 1px solid #6bb7be;
  transition: all 0.2s;
}
.blog_section .box .detail-box a:hover {
  background-color: transparent;
  color: #6bb7be;
}

.client_section .heading_container {
  align-items: center;
}
.client_section .box {
  display: flex;
  align-items: center;
  margin: 45px;
  padding: 35px 25px;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
}
.client_section .box .img-box {
  border-radius: 100%;
  border: 10px solid #6bb7be;
  margin-right: 25px;
  min-width: 175px;
  max-width: 175px;
  overflow: hidden;
}
.client_section .box .img-box img {
  width: 100%;
}
.client_section .box .detail-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.client_section .box .detail-box .name {
  text-align: center;
}
.client_section .box .detail-box .name img {
  width: 25px;
  margin-bottom: 5px;
}
.client_section .box .detail-box .name h6 {
  color: #6bb7be;
  font-size: 20px;
}
.client_section .carousel_btn-container {
  display: flex;
  justify-content: center;
}
.client_section .carousel-control-prev,
.client_section .carousel-control-next {
  position: unset;
  width: 45px;
  height: 45px;
  border: none;
  opacity: 1;
  background-repeat: no-repeat;
  background-size: 12px;
  background-position: center;
  background-color: #6bb7be;
  background-position: center;
  border-radius: 100%;
  margin: 0 2.5px;
}
.client_section .carousel-control-prev:hover,
.client_section .carousel-control-next:hover {
  background-color: #000000;
}
.client_section .carousel-control-next {
  left: initial;
}

.contact_section {
  position: relative;
  background-color: #f9fafa;
  padding-top: 75px;
  padding-bottom: 75px;
}
.contact_section .heading_container {
  margin-bottom: 25px;
}
.contact_section .heading_container h2 {
  text-transform: uppercase;
}
.contact_section .form_container input {
  width: 100%;
  border: none;
  height: 50px;
  margin-bottom: 25px;
  padding-left: 15px;
  outline: none;
  color: #101010;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.05);
}
.contact_section .form_container input::placeholder {
  color: #333;
}
.contact_section .form_container input.message-box {
  height: 120px;
}
.contact_section .form_container button {
  border: none;
  text-transform: uppercase;
  display: inline-block;
  padding: 12px 55px;
  background-color: #6bb7be;
  color: #ffffff;
  border-radius: 0px;
  border: 1px solid #6bb7be;
  transition: all 0.2s;
}
.contact_section .form_container button:hover {
  background-color: transparent;
  color: #6bb7be;
}
.contact_section .map_container {
  height: 500px;
  overflow: hidden;
  display: flex;
  align-items: stretch;
  padding: 0;
}
.contact_section .map_container .map {
  height: 100%;
  flex: 1 1;
}
.contact_section .map_container .map #googleMap {
  height: 100%;
}

.info_section {
  background-color: #191e1f;
  color: #ffffff;
  padding-top: 45px;
  padding-bottom: 45px;
}
.info_section .contact_nav {
  display: flex;
  justify-content: center;
  padding: 25px 0;
  text-align: center;
}
.info_section .contact_nav a {
  flex: 1 1;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #ffffff;
}
.info_section .contact_nav a i {
  font-size: 28px;
}
.info_section .contact_nav a:hover {
  color: #f89646;
}
.info_section .info_top {
  padding: 45px 0;
}
.info_section h4 {
  text-transform: uppercase;
  position: relative;
  margin-bottom: 25px;
}
.info_section .info_links .info_links_menu {
  display: flex;
  flex-wrap: wrap;
}
.info_section .info_links .info_links_menu a {
  color: #ffffff;
  flex-basis: 50%;
}
.info_section .info_links .info_links_menu a:hover, .info_section .info_links .info_links_menu a.active {
  color: #f89646;
}
.info_section .info_post .post_box {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.info_section .info_post .post_box .img-box {
  min-width: 65px;
  max-width: 65px;
  height: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  flex-basis: calc(33% - 10px);
  padding: 10px;
  margin: 5px;
}
.info_section .info_post .post_box .img-box img {
  max-width: 100%;
  max-height: 100%;
}
.info_section .info_post .post_box p {
  margin: 0;
}
.info_section .info_post .post_box:not(:nth-last-child(1)) {
  margin-bottom: 15px;
}
.info_section .info_form input {
  width: 100%;
  border: none;
  height: 45px;
  margin-bottom: 15px;
  padding-left: 25px;
  background-color: #eaeaea;
  outline: none;
  color: #101010;
}
.info_section .info_form button {
  display: inline-block;
  padding: 10px 45px;
  background-color: #6bb7be;
  color: #ffffff;
  border-radius: 0px;
  border: 1px solid #6bb7be;
  transition: all 0.2s;
}
.info_section .info_form button:hover {
  background-color: transparent;
  color: #6bb7be;
}
.info_section .info_form .social_box {
  width: 100%;
  display: flex;
  margin-top: 25px;
}
.info_section .info_form .social_box a {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  width: 45px;
  height: 45px;
  border: 1px solid #6bb7be;
  color: #6bb7be;
  font-size: 18px;
  margin-right: 10px;
}
.info_section .info_form .social_box a:hover {
  color: #f89646;
  border-color: #f89646;
}

/* footer section*/
.footer_section {
  position: relative;
  text-align: center;
}
.footer_section p {
  color: #000000;
  padding: 25px 0;
  margin: 0;
}
.footer_section p a {
  color: inherit;
}`, "",{"version":3,"sources":["webpack://./src/css/style.scss"],"names":[],"mappings":"AAMA,iBAAA;AACA;EACE,oBAAA;EACA,yFAAA;AALF;AAgCA;EACE,sBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AA9BF;;AAiCA;EACE,eAAA;AA9BF;;AAiCA;EACE,eAAA;AA9BF;;AAiCA;EACE,iBAAA;AA9BF;;AAiCA;EACE,oBAAA;AA9BF;;AAiCA;EACE,iBAAA;AA9BF;;AAiCA;EACE,oBAAA;AA9BF;;AAiCA;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AA9BF;AAgCE;EACE,kBAAA;EACA,iBAAA;EACA,yBAAA;AA9BJ;;AAsCA,iBAAA;AACA;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AAnCF;;AAwCE;EACE,gBAAA;AArCJ;;AA0CA;EACE,yBA3GM;AAoER;AAyCE;EACE,mBAAA;EACA,kBAAA;AAvCJ;AA0CE;EACE,cAAA;AAxCJ;;AA+CM;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;AA5CR;AAuDA;;;EAGE,qBAAA;AArDF;;AAwDA;;EAEE,cAAA;AArDF;;AAwDA;;EAEE,wBAAA;EACA,gBAAA;AArDF;;AAwDA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;AArDF;;AAyDE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;AAtDJ;;AA0DA;EACE,cAAA;EACA,cAAA;AAvDF;;AA0DA;EACE,aAAA;AAvDF;;AA0DA;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AAvDF;AAyDE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;AAvDJ;AAyDI;EAEE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,yBA3ME;EA4MF,mBAAA;EACA,UAAA;EACA,oBAAA;AAxDN;AA2DI;EACE,SAAA;AAzDN;AA6DE;EACE,yBAAA;AA3DJ;AA6DI;EACE,wBAAA;AA3DN;AA6DM;EAEE,wBAAA;EACA,MAAA;AA5DR;;AAkEA;EACE,aAAA;EACA,mBAAA;AA/DF;AAiEE;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;AA/DJ;AAiEI;EACE,iBAAA;AA/DN;;AAoEA,qBAAA;AAEA,mBAAA;AACA;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAzPO;AAuLT;AAqEE;EACE,mBAAA;AAnEJ;AAsEE;EACE,WAAA;EACA,UAAA;AApEJ;AAuEE;EACE,cAzQI;AAoMR;AAuEI;EACE,iBAAA;EACA,yBAAA;EACA,gBAAA;AArEN;AAwEI;EACE,cAAA;AAtEN;AAyEI;EACE,aAAA;EACA,cAAA;AAvEN;AAyEM;EACE,WAAA;EACA,kBAAA;EACA,YAAA;AAvER;AA0EM;EA/QJ,qBAAA;EACA,kBAAA;EACA,yBAhBS;EAiBT,cApBM;EAqBN,gBA4QuD;EA3QvD,yBAAA;EACA,oBAAA;AAwMF;AAtME;EACE,6BAAA;EACA,cAxBO;AAgOX;AAiEM;EAnRJ,qBAAA;EACA,kBAAA;EACA,yBAjBS;EAkBT,cApBM;EAqBN,gBAgRuD;EA/QvD,yBAAA;EACA,oBAAA;AAqNF;AAnNE;EACE,6BAAA;EACA,cAzBO;AA8OX;AA2DI;EACE,WAAA;AAzDN;AA6DE;EACE,eAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AA3DJ;AA6DI;EACE,yBAtTK;EAuTL,WAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;AA3DN;AA6DM;EACE,WAAA;EACA,YAAA;EACA,yBA9TG;AAmQX;;AAsEE;EACE,gBAAA;EAEA,yBAAA;EACA,aAAA;EACA,kBAAA;AApEJ;AAsEI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;AApEN;AAsEM;EACE,eAAA;EACA,gBAAA;AApER;AAwEI;EACE,gBAAA;AAtEN;AAwEM;EACE,yBAAA;EAEA,eAAA;AAvER;AA0EM;EACE,aAAA;EACA,8BAAA;AAxER;AA0EQ;EAKE,gBAAA;AA5EV;AAwEU;EACE,cA7WD;AAuSX;AA4EQ;EACE,cApXC;EAqXD,yBAAA;EACA,eAAA;AA1EV;;AAqFA;EACE,yBAhYO;AA8ST;AAoFE;EACE,mBAAA;AAlFJ;AAsFI;EACE,WAAA;AApFN;AAyFI;EACE,gBAAA;EACA,mBAAA;AAvFN;AA0FI;EArYF,qBAAA;EACA,kBAAA;EACA,yBAjBS;EAkBT,cApBM;EAqBN,gBAkYqD;EAjYrD,yBAAA;EACA,oBAAA;AA8SF;AA5SE;EACE,6BAAA;EACA,cAzBO;AAuUX;;AAyFE;EACE,mBAAA;AAtFJ;AAyFM;EACE,SAAA;EACA,2BAAA;AAvFR;AA4FE;EACE,gBAAA;EACA,yBA/aI;EAgbJ,0CAAA;AA1FJ;AA4FI;EACE,kBAAA;AA1FN;AA4FM;EACE,WAAA;AA1FR;AA8FI;EACE,aAAA;AA5FN;AA8FM;EACE,iBAAA;AA5FR;AAgGM;EACE,eAAA;EACA,WAAA;AA9FR;AAiGM;EAtbJ,qBAAA;EACA,kBAAA;EACA,yBAjBS;EAkBT,cApBM;EAqBN,gBAmbuD;EAlbvD,yBAAA;EACA,oBAAA;AAwVF;AAtVE;EACE,6BAAA;EACA,cAzBO;AAiXX;;AAgGE;EACE,mBAAA;AA7FJ;AAgGE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;AA9FJ;AAgGI;EACE,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AA9FN;AAgGM;EACE,WAAA;AA9FR;AAkGI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAhGN;AAkGM;EACE,kBAAA;AAhGR;AAkGQ;EACE,WAAA;EACA,kBAAA;AAhGV;AAmGQ;EACE,cAvfC;EAwfD,eAAA;AAjGV;AAuGE;EACE,aAAA;EACA,uBAAA;AArGJ;AAwGE;;EAEE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,4BAAA;EACA,qBAAA;EACA,2BAAA;EACA,yBA7gBO;EA8gBP,2BAAA;EACA,mBAAA;EACA,eAAA;AAtGJ;AAwGI;;EACE,yBAphBE;AA+aR;AAyGE;EACE,aAAA;AAvGJ;;AA8GA;EACE,kBAAA;EACA,yBA/hBO;EAgiBP,iBAAA;EACA,oBAAA;AA3GF;AA6GE;EACE,mBAAA;AA3GJ;AA6GI;EACE,yBAAA;AA3GN;AAkHI;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,yCAAA;AAhHN;AAkHM;EACE,WAAA;AAhHR;AAmHM;EACE,aAAA;AAjHR;AAqHI;EACE,YAAA;EACA,yBAAA;EAtjBJ,qBAAA;EACA,kBAAA;EACA,yBAjBS;EAkBT,cApBM;EAqBN,kBAmjBqD;EAljBrD,yBAAA;EACA,oBAAA;AAocF;AAlcE;EACE,6BAAA;EACA,cAzBO;AA6dX;AA6GE;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;EACA,UAAA;AA3GJ;AA6GI;EACE,YAAA;EACA,SAAA;AA3GN;AA6GM;EACE,YAAA;AA3GR;;AAsHA;EACE,yBAAA;EACA,cArmBM;EAsmBN,iBAAA;EACA,oBAAA;AAnHF;AAqHE;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAnHJ;AAqHI;EACE,SAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,cArnBE;AAkgBR;AAqHM;EACE,eAAA;AAnHR;AAsHM;EACE,cAznBG;AAqgBX;AAyHE;EACE,eAAA;AAvHJ;AA2HE;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;AAzHJ;AA8HI;EACE,aAAA;EACA,eAAA;AA5HN;AA8HM;EACE,cAnpBA;EAopBA,eAAA;AA5HR;AA8HQ;EAEE,cArpBC;AAwhBX;AAoII;EACE,aAAA;EACA,eAAA;EACA,mBAAA;AAlIN;AAoIM;EACE,eAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBA3qBA;EA4qBA,4BAAA;EACA,aAAA;EACA,WAAA;AAlIR;AAoIQ;EACE,eAAA;EACA,gBAAA;AAlIV;AAsIM;EACE,SAAA;AApIR;AAuIM;EACE,mBAAA;AArIR;AA2II;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;AAzIN;AA4II;EA3rBF,qBAAA;EACA,kBAAA;EACA,yBAjBS;EAkBT,cApBM;EAqBN,kBAwrBqD;EAvrBrD,yBAAA;EACA,oBAAA;AAkjBF;AAhjBE;EACE,6BAAA;EACA,cAzBO;AA2kBX;AAoII;EACE,WAAA;EACA,aAAA;EACA,gBAAA;AAlIN;AAoIM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,cA5tBG;EA6tBH,eAAA;EACA,kBAAA;AAlIR;AAoIQ;EACE,cAhuBC;EAiuBD,qBAjuBC;AA+lBX;;AA6IA,kBAAA;AAEA;EACE,kBAAA;EACA,kBAAA;AA3IF;AA6IE;EACE,cArvBI;EAsvBJ,eAAA;EACA,SAAA;AA3IJ;AA6II;EACE,cAAA;AA3IN","sourcesContent":["$white: #ffffff;\r\n$black: #000000;\r\n$primary1: #6bb7be;\r\n$primary2: #f89646;\r\n$bgColor:#f9fafa;\r\n\r\n/* fonts import */\r\n@font-face {\r\n  font-family: \"octin\";\r\n  src: local(\"octin_sports_rg\"), url('../fonts/octin_sports_rg.ttf') format(\"truetype\");\r\n}\r\n\r\n@mixin main-font {\r\n  font-family: \"Poppins\", sans-serif;\r\n}\r\n\r\n@mixin hero_btn($col1, $col2, $pad1, $pad2, $bRadius) {\r\n  display: inline-block;\r\n  padding: $pad1 $pad2;\r\n  background-color: $col1;\r\n  color: $col2;\r\n  border-radius: $bRadius;\r\n  border: 1px solid $col1;\r\n  transition: all .2s;\r\n\r\n  &:hover {\r\n    background-color: transparent;\r\n    color: $col1;\r\n  }\r\n}\r\n\r\n@mixin upperBold {\r\n  text-transform: uppercase;\r\n  font-weight: bold;\r\n}\r\n\r\nbody {\r\n  font-family: \"Poppins\";\r\n  color: #0c0c0c;\r\n  background-color: #ffffff;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.layout_padding {\r\n  padding: 90px 0;\r\n}\r\n\r\n.layout_padding2 {\r\n  padding: 45px 0;\r\n}\r\n\r\n.layout_padding2-top {\r\n  padding-top: 45px;\r\n}\r\n\r\n.layout_padding2-bottom {\r\n  padding-bottom: 45px;\r\n}\r\n\r\n.layout_padding-top {\r\n  padding-top: 90px;\r\n}\r\n\r\n.layout_padding-bottom {\r\n  padding-bottom: 90px;\r\n}\r\n\r\n.long_section {\r\n  margin-left: 45px;\r\n  margin-right: 45px;\r\n  padding-left: 15px;\r\n  padding-right: 15px;\r\n}\r\n\r\n.heading_container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n\r\n  h1,h2 {\r\n    position: relative;\r\n    font-weight: bold;\r\n    text-transform: uppercase;\r\n\r\n  }\r\n}\r\n\r\nh1,\r\nh2 {}\r\n\r\n/*header section*/\r\n.hero_area {\r\n  min-height: 100vh;\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n}\r\n\r\n.sub_page {\r\n  .hero_area {\r\n    min-height: auto;\r\n\r\n  }\r\n}\r\n\r\n.header_section {\r\n  background-color: $white;\r\n\r\n  .container-fluid {\r\n    padding-right: 25px;\r\n    padding-left: 25px;\r\n  }\r\n\r\n  .nav_container {\r\n    margin: 0 auto;\r\n  }\r\n}\r\n\r\n.custom_nav-container {\r\n  .navbar-nav {\r\n    .nav-item {\r\n      .nav-link {\r\n        padding: 3px 15px;\r\n        margin: 10px 15px;\r\n        color: #272727;\r\n        text-align: center;\r\n        text-transform: uppercase;\r\n      }\r\n\r\n      &.active,\r\n      &:hover {\r\n        .nav-link {}\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\na,\r\na:hover,\r\na:focus {\r\n  text-decoration: none;\r\n}\r\n\r\na:hover,\r\na:focus {\r\n  color: initial;\r\n}\r\n\r\n.btn,\r\n.btn:focus {\r\n  outline: none !important;\r\n  box-shadow: none;\r\n}\r\n\r\n.custom_nav-container .nav_search-btn {\r\n  width: 35px;\r\n  height: 35px;\r\n  padding: 0;\r\n  border: none;\r\n}\r\n\r\n.navbar-brand {\r\n  span {\r\n    font-size: 24px;\r\n    font-weight: 700;\r\n    color: #272727;\r\n    text-transform: uppercase;\r\n  }\r\n}\r\n\r\n.custom_nav-container {\r\n  z-index: 99999;\r\n  padding: 5px 0;\r\n}\r\n\r\n.custom_nav-container .navbar-toggler {\r\n  outline: none;\r\n}\r\n\r\n.custom_nav-container .navbar-toggler {\r\n  padding: 0;\r\n  width: 37px;\r\n  height: 42px;\r\n  transition: all 0.3s;\r\n\r\n  span {\r\n    display: block;\r\n    width: 32px;\r\n    height: 4px;\r\n    background-color: #000;\r\n    border-radius: 15px;\r\n    margin: 7px 0;\r\n    transition: all 0.3s;\r\n    position: relative;\r\n    transition: all 0.3s;\r\n\r\n    &::before,\r\n    &::after {\r\n      content: \"\";\r\n      position: absolute;\r\n      left: 0;\r\n      height: 100%;\r\n      width: 100%;\r\n      background-color: $black;\r\n      border-radius: 15px;\r\n      top: -10px;\r\n      transition: all 0.3s;\r\n    }\r\n\r\n    &::after {\r\n      top: 10px;\r\n    }\r\n  }\r\n\r\n  &[aria-expanded=\"true\"] {\r\n    transform: rotate(360deg); \r\n\r\n    span {\r\n      transform: rotate(45deg); \r\n\r\n      &::before,\r\n      &::after {\r\n        transform: rotate(90deg);\r\n        top: 0;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.quote_btn-container {\r\n  display: flex;\r\n  align-items: center;\r\n\r\n  a {\r\n    color: #151515;\r\n    margin-right: 25px;\r\n    text-transform: uppercase;\r\n\r\n    span {\r\n      margin-right: 5px;\r\n    }\r\n  }\r\n}\r\n\r\n/*end header section*/\r\n\r\n/* slider section */\r\n.slider_section {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  position: relative;\r\n  background-color: $bgColor;\r\n\r\n\r\n  .row {\r\n    align-items: center;\r\n  }\r\n\r\n  #customCarousel {\r\n    width: 100%;\r\n    z-index: 3;\r\n  }\r\n\r\n  .detail-box {\r\n    color: $black;\r\n\r\n    h1 {\r\n      font-weight: bold;\r\n      text-transform: uppercase;\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    p {\r\n      margin: 25px 0;\r\n    }\r\n\r\n    .btn-box {\r\n      display: flex;\r\n      margin: 0 -5px;\r\n\r\n      a {\r\n        margin: 5px;\r\n        text-align: center;\r\n        width: 165px;\r\n      }\r\n\r\n      .btn1 {\r\n        @include hero_btn($primary2, $white, 10px, 15px, 0);\r\n      }\r\n\r\n      .btn2 {\r\n        @include hero_btn($primary1, $white, 10px, 15px, 0);\r\n      }\r\n    }\r\n  }\r\n\r\n  .img-box {\r\n    img {\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  .carousel-indicators {\r\n    position: unset;\r\n    margin: 0;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin-top: 45px;\r\n\r\n    li {\r\n      background-color: $primary1;\r\n      width: 12px;\r\n      height: 12px;\r\n      border-radius: 100%;\r\n      opacity: 1;\r\n\r\n      &.active {\r\n        width: 17px;\r\n        height: 17px;\r\n        background-color: $primary2;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// end slider section\r\n\r\n// furniture section\r\n\r\n.furniture_section {\r\n  .box {\r\n    margin-top: 45px;\r\n    // box-shadow: 0 0 5px 0 rgba($color: #000000, $alpha: .25);\r\n    background-color: #f7fafa;\r\n    padding: 25px;\r\n    border-radius: 5px;\r\n\r\n    .img-box {\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n      height: 275px;\r\n      padding: 25px;\r\n\r\n      img {\r\n        max-width: 100%;\r\n        max-height: 100%;\r\n      }\r\n    }\r\n\r\n    .detail-box {\r\n      margin-top: 15px;\r\n\r\n      h5 {\r\n        text-transform: uppercase;\r\n\r\n        font-size: 18px;\r\n      }\r\n\r\n      .price_box {\r\n        display: flex;\r\n        justify-content: space-between;\r\n\r\n        .price_heading {\r\n          span {\r\n            color: $primary1;\r\n          }\r\n\r\n          margin-bottom: 0;\r\n        }\r\n\r\n        a {\r\n          color: $primary1;\r\n          text-transform: uppercase;\r\n          font-size: 15px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// end furniture section\r\n\r\n// about section\r\n\r\n.about_section {\r\n  background-color: $bgColor;\r\n\r\n  .row {\r\n    align-items: center;\r\n  }\r\n\r\n  .img-box {\r\n    img {\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  .detail-box {\r\n    p {\r\n      margin-top: 10px;\r\n      margin-bottom: 35px;\r\n    }\r\n\r\n    a {\r\n      @include hero_btn($primary1, $white, 10px, 45px, 0);\r\n    }\r\n  }\r\n}\r\n\r\n// end about section\r\n\r\n\r\n\r\n// blog section\r\n.blog_section {\r\n  .heading_container {\r\n    align-items: center;\r\n\r\n    h2 {\r\n      &::before {\r\n        left: 50%;\r\n        transform: translateX(-50%);\r\n      }\r\n    }\r\n  }\r\n\r\n  .box {\r\n    margin-top: 55px;\r\n    background-color: $white;\r\n    box-shadow: 0 0 10px 0 rgba($color: #000000, $alpha: 0.15);\r\n\r\n    .img-box {\r\n      position: relative;\r\n\r\n      img {\r\n        width: 100%;\r\n      }\r\n    }\r\n\r\n    .detail-box {\r\n      padding: 25px;\r\n\r\n      h5 {\r\n        font-weight: bold;\r\n\r\n      }\r\n\r\n      p {\r\n        font-size: 15px;\r\n        color: #444;\r\n      }\r\n\r\n      a {\r\n        @include hero_btn($primary1, $white, 10px, 30px, 0);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// end blog section\r\n\r\n// client section\r\n\r\n.client_section {\r\n  .heading_container {\r\n    align-items: center;\r\n  }\r\n\r\n  .box {\r\n    display: flex;\r\n    align-items: center;\r\n    margin: 45px;\r\n    padding: 35px 25px;\r\n    box-shadow: 0 0 15px 0 rgba($color: #000000, $alpha: 0.15);\r\n\r\n    .img-box {\r\n      border-radius: 100%;\r\n      border: 10px solid $primary1;\r\n      margin-right: 25px;\r\n      min-width: 175px;\r\n      max-width: 175px;\r\n      overflow: hidden;\r\n\r\n      img {\r\n        width: 100%;\r\n      }\r\n    }\r\n\r\n    .detail-box {\r\n      display: flex;\r\n      flex-direction: column;\r\n      align-items: flex-start;\r\n\r\n      .name {\r\n        text-align: center;\r\n\r\n        img {\r\n          width: 25px;\r\n          margin-bottom: 5px;\r\n        }\r\n\r\n        h6 {\r\n          color: $primary1;\r\n          font-size: 20px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .carousel_btn-container {\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n\r\n  .carousel-control-prev,\r\n  .carousel-control-next {\r\n    position: unset;\r\n    width: 45px;\r\n    height: 45px;\r\n    border: none;\r\n    opacity: 1;\r\n    background-repeat: no-repeat;\r\n    background-size: 12px;\r\n    background-position: center;\r\n    background-color: $primary1;\r\n    background-position: center;\r\n    border-radius: 100%;\r\n    margin: 0 2.5px;\r\n\r\n    &:hover {\r\n      background-color: $black;\r\n    }\r\n  }\r\n\r\n  .carousel-control-next {\r\n    left: initial;\r\n  }\r\n}\r\n\r\n// end client section\r\n\r\n// contact section\r\n.contact_section {\r\n  position: relative;\r\n  background-color: $bgColor;\r\n  padding-top: 75px;\r\n  padding-bottom: 75px;\r\n\r\n  .heading_container {\r\n    margin-bottom: 25px;\r\n\r\n    h2 {\r\n      text-transform: uppercase;\r\n    }\r\n  }\r\n\r\n\r\n  .form_container {\r\n\r\n    input {\r\n      width: 100%;\r\n      border: none;\r\n      height: 50px;\r\n      margin-bottom: 25px;\r\n      padding-left: 15px;\r\n      outline: none;\r\n      color: #101010;\r\n      box-shadow: 0 0 5px 0 rgba($color: #000000, $alpha: .05);\r\n\r\n      &::placeholder {\r\n        color: #333;\r\n      }\r\n\r\n      &.message-box {\r\n        height: 120px;\r\n      }\r\n    }\r\n\r\n    button {\r\n      border: none;\r\n      text-transform: uppercase;\r\n      @include hero_btn($primary1, $white, 12px, 55px, 0px);\r\n    }\r\n  }\r\n\r\n  .map_container {\r\n    height: 500px;\r\n    overflow: hidden;\r\n    display: flex;\r\n    align-items: stretch;\r\n    padding: 0;\r\n\r\n    .map {\r\n      height: 100%;\r\n      flex: 1;\r\n\r\n      #googleMap {\r\n        height: 100%;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// end contact section\r\n\r\n\r\n\r\n// info section\r\n.info_section {\r\n  background-color: #191e1f;\r\n  color: $white;\r\n  padding-top: 45px;\r\n  padding-bottom: 45px;\r\n\r\n  .contact_nav {\r\n    display: flex;\r\n    justify-content: center;\r\n    padding: 25px 0;\r\n    text-align: center;\r\n\r\n    a {\r\n      flex: 1;\r\n      margin: 0;\r\n      display: flex;\r\n      flex-direction: column;\r\n      align-items: center;\r\n      color: $white;\r\n\r\n      i {\r\n        font-size: 28px;\r\n      }\r\n\r\n      &:hover {\r\n        color: $primary2;\r\n      }\r\n    }\r\n  }\r\n\r\n  .info_top {\r\n    padding: 45px 0;\r\n  }\r\n\r\n\r\n  h4 {\r\n    text-transform: uppercase;\r\n    position: relative;\r\n    margin-bottom: 25px;\r\n\r\n  }\r\n\r\n  .info_links {\r\n    .info_links_menu {\r\n      display: flex;\r\n      flex-wrap: wrap;\r\n\r\n      a {\r\n        color: $white;\r\n        flex-basis: 50%;\r\n\r\n        &:hover,\r\n        &.active {\r\n          color: $primary2;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .info_post {\r\n    .post_box {\r\n      display: flex;\r\n      flex-wrap: wrap;\r\n      align-items: center;\r\n\r\n      .img-box {\r\n        min-width: 65px;\r\n        max-width: 65px;\r\n        height: 65px;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        background-color: $white;\r\n        flex-basis: calc(33% - 10px);\r\n        padding: 10px;\r\n        margin: 5px;\r\n\r\n        img {\r\n          max-width: 100%;\r\n          max-height: 100%;\r\n        }\r\n      }\r\n\r\n      p {\r\n        margin: 0;\r\n      }\r\n\r\n      &:not(:nth-last-child(1)) {\r\n        margin-bottom: 15px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .info_form {\r\n    input {\r\n      width: 100%;\r\n      border: none;\r\n      height: 45px;\r\n      margin-bottom: 15px;\r\n      padding-left: 25px;\r\n      background-color: #eaeaea;\r\n      outline: none;\r\n      color: #101010;\r\n    }\r\n\r\n    button {\r\n      @include hero_btn($primary1, $white, 10px, 45px, 0px);\r\n\r\n    }\r\n\r\n    .social_box {\r\n      width: 100%;\r\n      display: flex;\r\n      margin-top: 25px;\r\n\r\n      a {\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        border-radius: 5px;\r\n        width: 45px;\r\n        height: 45px;\r\n        border: 1px solid $primary1;\r\n        color: $primary1;\r\n        font-size: 18px;\r\n        margin-right: 10px;\r\n\r\n        &:hover {\r\n          color: $primary2;\r\n          border-color: $primary2;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n\r\n}\r\n\r\n// end info section\r\n\r\n/* footer section*/\r\n\r\n.footer_section {\r\n  position: relative;\r\n  text-align: center;\r\n\r\n  p {\r\n    color: $black;\r\n    padding: 25px 0;\r\n    margin: 0;\r\n\r\n    a {\r\n      color: inherit;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// end footer section"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
